import React from 'react';
import { ArrowUpIcon, ArrowDownIcon, ArrowUpDownIcon } from 'lucide-react';
import { SortDirection } from '../../hooks/useSortableData';
interface SortableHeaderProps {
  label: string;
  sortKey: string;
  currentDirection: SortDirection;
  onSort: (key: string) => void;
  className?: string;
  align?: 'left' | 'right' | 'center';
}
export function SortableHeader({
  label,
  sortKey,
  currentDirection,
  onSort,
  className = '',
  align = 'left'
}: SortableHeaderProps) {
  const alignClass = align === 'right' ? 'text-right justify-end' : align === 'center' ? 'text-center justify-center' : 'text-left';
  return <th className={`py-4 px-6 text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wider cursor-pointer select-none group hover:text-gray-700 dark:hover:text-gray-200 transition-colors ${alignClass} ${className}`} onClick={() => onSort(sortKey)} data-id="element-4151">
      <span className={`inline-flex items-center gap-1.5 ${align === 'right' ? 'flex-row-reverse' : ''}`} data-id="element-4152">
        {label}
        <span className="flex-shrink-0 w-3.5 h-3.5 flex items-center justify-center" data-id="element-4153">
          {currentDirection === 'asc' ? <ArrowUpIcon className="w-3.5 h-3.5 text-sky-500" data-id="element-4154" /> : currentDirection === 'desc' ? <ArrowDownIcon className="w-3.5 h-3.5 text-sky-500" data-id="element-4155" /> : <ArrowUpDownIcon className="w-3.5 h-3.5 text-gray-300 dark:text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-4156" />}
        </span>
      </span>
    </th>;
}